import { ENGLISH_TRANSLATIONS } from './English';
import { NORWEGIAN_TRANSLATIONS } from './Norwegian';

export const TRANSLATIONS = {
  English: ENGLISH_TRANSLATIONS,
  Norwegian: NORWEGIAN_TRANSLATIONS
};
